import { Injectable } from '@angular/core';

import { Capacitor } from '@capacitor/core';
import {
  CapacitorSQLite, /*SQLiteDBConnection,*/
  SQLiteConnection,
  CapacitorSQLitePlugin,
  SQLiteDBConnection
} from '@capacitor-community/sqlite';
import LocalDataSource, {sqliteConnection} from '../data-sources/LocalDataSource';
import { Pessoa } from '../domain/Pessoa';
import {capSQLiteResult} from "@capacitor-community/sqlite/src/definitions";
import {Platform} from "@ionic/angular";

@Injectable()

export class SQLiteService {
    sqliteConnection: SQLiteConnection;
    isService = false;
    platform: string;
    sqlitePlugin: any;
    native = false;
    db?: SQLiteDBConnection

    constructor() {
      this.platform = Capacitor.getPlatform();
      if(this.platform === 'ios' || this.platform === 'android') {this.native = true;}
      this.sqlitePlugin = CapacitorSQLite;
      this.sqliteConnection = new SQLiteConnection(this.sqlitePlugin);

      this.isService = true;
    }

    async getConexao(){
      if(this.db) return this.db
      let db: SQLiteDBConnection

      const dbName = "fauna"
      const readonly = false
      const retCC = (await this.sqliteConnection.checkConnectionsConsistency()).result;
      let isConn = (await this.sqliteConnection.isConnection(dbName, readonly)).result;
      if(retCC && isConn) {
        db = await this.sqliteConnection.retrieveConnection(dbName, readonly);
      } else {
        db = await this.sqliteConnection
          .createConnection(dbName, false, 'no-encryption', 0, readonly);
      }
      await db.open();
      return db;
    }

    async saveToStore(){
      if(Capacitor.getPlatform() === 'web') {
        await this.sqliteConnection.saveToStore("fauna")
        console.log('salvando no BD no store')
      } else{
        console.log('platform', Capacitor.getPlatform())
      }
    }

    async initialize(){
        await this.initializeWebStore()
      // console.log('existente', existente)
          console.log('vai copiar')
      try {
        await sqliteConnection.copyFromAssets(false)
      }catch (e) {
        console.log('não sobrescreveu o bd', e)
      }
        await LocalDataSource.initialize()
        console.log(`*** dataSource has been initialized ***`)
        await LocalDataSource.runMigrations()
        console.log(`*** dataSource runMigration has been run succesfully ***`)

        // try {
        //   //Somente para evitar o erro da primeira
        //   const p = new Pessoa()
        //   const repo = LocalDataSource.getRepository(Pessoa)
        //   repo.save(p)
        // }catch(ex){
        //   console.log(ex)
        // }
    }

    async initializeWebStore() {
      if(this.platform === 'web') {
        try {
          await this.sqliteConnection.initWebStore();
        } catch (err) {
          console.log(`Error: ${err}`);
          throw new Error(`Error: ${err}`)
        }
      }
    }
    /**
     * Get the Sqlite Plugin
     * @returns
     */
    getSqlitePlugin(): CapacitorSQLitePlugin {
      return this.sqlitePlugin;
    }
    /**
     * Get the Platform
     * @returns
     */
    getPlatform(): string {
      return this.platform;
    }
    /**
     * Get the Sqlite Connection
     * @returns
     */
    getSqliteConnection(): SQLiteConnection {
      return this.sqliteConnection;
    }
    /**
     * Get if the platform is native
     * @returns
     */
    getIsNative(): boolean {
      return this.native;
    }
    /**
     * Get if the service is initialized
     * @returns
     */
    getIsService(): boolean {
      return this.isService;
    }
    /**
     * Check Connection Consistency
     * @returns
     */
    async checkConnectionConsistency(): Promise<void> {
      try {
/*        await this.sqlitePlugin.checkConnectionsConsistency({
          dbNames: [], // i.e. "i expect no connections to be open"
        });
*/
        await this.sqliteConnection.checkConnectionsConsistency();
      } catch (err: any) {
        const msg = err.message ? err.message : err;
        return Promise.reject(`Error: ${msg}`);
      }
    }

  async isExists(): Promise<boolean> {
    const cnn = await this.getConexao()
    const exist = await cnn.isExists()
    console.log(exist)
    return exist.result||false
  }
}
